import ComponentName from '@Constant/componentName'

const login = [
  {
    component: () => import('../views/login/Index.vue'),
    path: '/login',
    name: ComponentName.login,
    auth: '*',
    meta: {
      title: '登陆'
    }
  },
  {
    component: () => import('../views/register/Index.vue'),
    path: '/register',
    name: ComponentName.register.index,
    auth: '*',
    meta: {
      title: '申请入驻'
    }
  },
  {
    component: () => import('../views/retention/Index.vue'),
    path: '/retention',
    name: ComponentName.retention.index,
    auth: '*',
    meta: {
      title: '留资申请'
    }
  }
]

export default login
